import {
  AppBar,
  Avatar,
  Button,
  Grid,
  IconButton,
  Modal,
  Paper,
  Stack,
  Toolbar,
  Typography,
  Autocomplete,
  TextField
} from '@mui/material';
import { Tune, Menu as MenuIcon } from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Image } from '../Image';
import { Logo } from '../../assets/images';
import { useEffect, useState } from 'react';
import { useOrganizations } from '../../customHooks';
import { AiOutlineLogout } from 'react-icons/ai';
import { request, toast } from '../../utils';





import  { socket } from '../../utils';

export const Navbar = ({ showSideBarOption, handleSidebarOpen }) => {
  const navigate = useNavigate();
  const { organizationOptions } = useOrganizations();
  const [anchorEl, setAnchorEl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [openSideBar, setOpenSideBar] = useState(false);
  const location = useLocation();
  const [searchOptions, setSearchOptions] = useState([]);

  const user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null;
  const isSuperAdmin = user ? user.superadmin : false;
  const permissions = user && user.permissions ? user.permissions : []; // Safely access permissions

  const filteredOptions = organizationOptions?.filter(
    (option) => isSuperAdmin || permissions.some((permission) => permission.includes(option.id))
  );


  const filteredOptionsforSocket = organizationOptions?.filter(
    (option) =>  permissions.some((permission) => permission.includes(option.id))
  );
  

  const moduleArray = filteredOptionsforSocket && filteredOptionsforSocket.map(option => option.id)
  
  useEffect(() => {
    // Check if moduleArray is not empty
    if (moduleArray && moduleArray.length > 0) {
      // Join rooms (modules) on component mount
      socket.emit('joinRooms', {
        username: user?.username || 'Anonymous',
        rooms: moduleArray
      });

      // Listen for notifications
      const notificationListener = (data) => {
        console.log('Notification received:', data);
        toast(`Notification from ${data.room}: ${data.message}`, { variant: 'success' });

        // Play notification sound
        const audio = new Audio('/play.mp3');
        audio.volume = 1;  // Volume from 0 to 1
        audio.loop = false;  // Set to true if you want the sound to repeat
        audio.play().catch((error) => {
          console.error('Failed to play notification sound:', error);
        });

        // Optional: Speak the message
        // const synth = window.speechSynthesis;
        // const utterance = new SpeechSynthesisUtterance(data.message);
        // synth.speak(utterance);
      };

      socket.on('receiveNotification', notificationListener);

      // Cleanup the listener on component unmount or when moduleArray or username changes
      return () => {
        socket.off('receiveNotification', notificationListener);
      };
    }
  }, [moduleArray, user?.username]);


  useEffect(() => {
    if (['/hospital', '/group', '/lab', '/pharmacy'].includes(location.pathname)) {
      setOpenSideBar(true);
    } else {
      setOpenSideBar(false);
    }
  }, [location.pathname]);

  const handleMenu = (e) => {
    setAnchorEl(e.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    // Clear local storage
    localStorage.clear();
    navigate('/');
  };

  const flattenedOptions =
    filteredOptions?.flatMap((option) =>
      option.menu.flatMap((menuItem) => {
        const items = [
          {
            label: menuItem.label,
            to: menuItem.to,
            id: menuItem.id
          },
          ...(menuItem.children?.flatMap((child) => {
            const childItems = [
              {
                label: child.label,
                to: child.to,
                id: child.id
              }
            ];
            if (child.children) {
              childItems.push(
                ...child.children.map((grandChild) => ({
                  label: grandChild.label,
                  to: grandChild.to,
                  id: grandChild.id
                }))
              );
            }
            return childItems;
          }) || [])
        ];
        return items;
      })
    ) || [];
   
  const handleInputChange = (event, value) => {
    if (value && value.length >= 3) {
      const filtered = flattenedOptions.filter((option) => option.label.toLowerCase().startsWith(value.toLowerCase()));
      setSearchOptions(filtered);
    } else {
      setSearchOptions([]);
    }
  }; 
  return (
    <AppBar component="nav" position="static" sx={{ boxShadow: 'none', height: '50px' }}>
      <Toolbar sx={{ justifyContent: 'space-between' }}>
        <Stack direction="row" spacing={2} alignItems="center">
          <Image
            onClick={() => navigate('/home')}
            sx={{ width: '15rem', height: '4rem', cursor: 'pointer' }}
            src={Logo.default}
            alt="Logo"
          />
          {filteredOptions && (
            <IconButton onClick={handleSidebarOpen} sx={{ color: 'black' }}>
              <MenuIcon fontSize="large" />
            </IconButton>
          )}
        </Stack>
        {filteredOptions && (
          <Autocomplete
            options={searchOptions}
            sx={{
              marginBottom: '1%',
              background: '#E0F7F7',
              width: '30%',
              '& .MuiOutlinedInput-root': {
                padding: '0'
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 14px'
              }
            }}
            getOptionLabel={(option) => option?.label || ''}
            renderInput={(params) => <TextField {...params} variant="outlined" sx={{ width: '100%' }} />}
            onInputChange={handleInputChange}
            onChange={(event, value) => {
              if (value) {
                window.open(value.to, '_blank');
              }
            }}
          />
        )}
        <Stack direction="row" spacing={2}>
          <Stack direction="row" spacing={2} sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
            {' '}
            <AiOutlineLogout size={20} color="red" onClick={() => handleLogout()} />
          </Stack>
          {organizationOptions && (
            <IconButton onClick={handleMenu} sx={{ color: 'black' }}>
              <Tune fontSize="large" />
            </IconButton>
          )}
          <Modal
            id="menu-appbar"
            open={Boolean(anchorEl) || openSideBar}
            onClose={handleClose}
            aria-labelledby="organization-options"
            aria-describedby="organization-options-description"
          >
            <Stack
              direction="column"
              justifyContent="center"
              alignItems="center"
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '97%',
                maxHeight: '100%',
                height: '100%',
                boxShadow: 24,
                p: 2,
                overflow: 'auto'
              }}
            >
              <Grid
                container
                spacing={1}
                sx={{
                  maxWidth: '100%',
                  p: 1
                }}
              >
                {filteredOptions?.map((data) => (
                  <Grid item xs={12} sm={2} key={data.id}>
                    <Paper
                      key={data.id}
                      sx={{
                        p: 2,
                        height: '100%',
                        cursor: 'pointer',
                        transition: 'background-color 0.3s ease',
                        '&:hover': {
                          backgroundColor: 'hover.options'
                        }
                      }}
                      onClick={() => {
                        navigate(data.to);
                        handleClose();
                      }}
                    >
                      <Image
                        src={data.img.default}
                        alt={data.label}
                        sx={{
                          mx: 'auto',
                          borderRadius: '100%',
                          width: '5rem',
                          overflow: 'hidden',
                          aspectRatio: '1/1'
                        }}
                      />
                      <Typography textTransform="uppercase" textAlign="center" fontWeight="bold">
                        {data.label}
                      </Typography>
                    </Paper>
                  </Grid>
                ))}
              </Grid>
            </Stack>
          </Modal>
          {/* {user && (
            <Avatar sx={{ cursor: 'pointer' }} variant="rounded">
              {user.role}
            </Avatar>
          )} */}
        </Stack>
      </Toolbar>
    </AppBar>
  );
};

// import { AppBar, Avatar, Grid, IconButton, Menu, Paper, Stack, Toolbar, Typography } from '@mui/material';
// import { Tune, Menu as MenuIcon, Height } from '@mui/icons-material';
// import { useNavigate } from 'react-router-dom';
// import { useSelector } from 'react-redux';
// import { Image } from '../Image';
// import { Logo } from '../../assets/images';
// import { useState } from 'react';
// import { useOrganizations } from '../../customHooks';

// export const Navbar = ({ showSideBarOption, handleSidebarOpen }) => {
//   const navigate = useNavigate();
//   const { user } = useSelector((state) => state.user);
//   const { organizationOptions } = useOrganizations();

//   const [anchorEl, setAnchorEl] = useState(null);

//   const handleMenu = (e) => {
//     setAnchorEl(e.currentTarget);
//   };
//   const handleClose = () => {
//     setAnchorEl(null);
//   };

//   return (
//     <AppBar component="nav" position="static" sx={{ boxShadow: 'none', height: '50px' }}>
//       <Toolbar sx={{ justifyContent: 'space-between' }}>
//         <Stack direction="row" spacing={2} alignItems="center">
//           <Image
//             onClick={() => navigate('/')}
//             sx={{ width: '15rem', cursor: 'pointer' }}
//             src={Logo.default}
//             alt="Logo"
//           />
//           {showSideBarOption && (
//             <IconButton onClick={handleSidebarOpen} sx={{ color: 'grey' }}>
//               <MenuIcon fontSize="large" />
//             </IconButton>
//           )}
//         </Stack>
//         <Stack direction="row" spacing={2}>
//           {organizationOptions && (
//             <IconButton onClick={handleMenu} sx={{ color: 'black' }}>
//               <Tune fontSize="large" />
//             </IconButton>
//           )}
//           <Menu
//             id="menu-appbar"
//             anchorEl={anchorEl}
//             anchorOrigin={{
//               vertical: 'top',
//               horizontal: 'right'
//             }}
//             keepMounted
//             transformOrigin={{
//               vertical: 'top',
//               horizontal: 'right'
//             }}
//             open={Boolean(anchorEl)}
//             onClose={handleClose}
//             sx={{ display: 'flex', gap: '10px' }}
//           >
//             <Grid
//               container
//               spacing={2}
//               sx={{
//                 maxWidth: '40vw',
//                 p: 1
//               }}
//             >
//               {organizationOptions?.map((data) => (
//                 <Grid item xs={12} sm={3} key={data.id}>
//                   <Paper
//                     key={data.id}
//                     sx={{
//                       p: 2,
//                       cursor: 'pointer',
//                       transition: 'background-color 0.3s ease',
//                       '&:hover': {
//                         backgroundColor: 'hover.options'
//                       }
//                     }}
//                     onClick={() => navigate(data.to)}
//                   >
//                     <Image
//                       src={data.img.default}
//                       alt={data.label}
//                       sx={{
//                         mx: 'auto',
//                         borderRadius: '100%',
//                         width: '5rem',
//                         overflow: 'hidden',
//                         aspectRatio: '1/1'
//                       }}
//                     />
//                     <Typography textTransform="uppercase" textAlign="center" fontWeight="bold">
//                       {data.label}
//                     </Typography>
//                   </Paper>
//                 </Grid>
//               ))}
//             </Grid>
//           </Menu>
//           {user && (
//             <Avatar sx={{ cursor: 'pointer' }} variant="rounded">
//               A
//             </Avatar>
//           )}
//         </Stack>
//       </Toolbar>
//     </AppBar>
//   );
// };
